import React from 'react';
import Reveal from '../../../components/shared/Reveal';
import { EditableText } from '../../components';
import { getIcon } from '../iconMap';

function EthosPillars({ data, onChange }) {
  const update = (patch) => onChange && onChange({ ...data, ...patch });
  const items = data.items || [];
  const updateItem = (i, patch) => {
    const next = items.map((x, idx) => (idx === i ? { ...x, ...patch } : x));
    update({ items: next });
  };
  return (
    <section className="py-24 bg-white">
      <div className="container-page">
        <Reveal className="max-w-3xl">
          <span className="eyebrow"><span className="h-px w-8 bg-olive" />
            <EditableText value={data.eyebrow} onChange={(t) => update({ eyebrow: t })} as="span" />
          </span>
          <h2 className="section-title mt-4">
            <EditableText value={data.heading} onChange={(t) => update({ heading: t })} as="span" />
          </h2>
          <p className="section-lead">
            <EditableText value={data.lead} onChange={(t) => update({ lead: t })} as="span" multiline />
          </p>
        </Reveal>
        <div className="mt-14 grid md:grid-cols-3 gap-6">
          {items.map((p, i) => {
            const I = getIcon(p.icon);
            return (
              <Reveal key={i} delay={i * 0.1}>
                <div className="group p-8 rounded-3xl border border-olive/10 hover:border-accent/40 hover:shadow-soft transition-all hover:-translate-y-1 h-full">
                  <div className="inline-flex h-14 w-14 items-center justify-center rounded-2xl bg-olive text-white group-hover:bg-accent group-hover:text-ink transition"><I size={26} /></div>
                  <EditableText value={p.title} onChange={(t) => updateItem(i, { title: t })} as="h3" className="font-display text-2xl mt-6" />
                  <EditableText value={p.desc} onChange={(t) => updateItem(i, { desc: t })} as="p" multiline className="mt-3 text-ink/70 leading-relaxed" />
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
}

export default EthosPillars;
